module.exports = __webpack_public_path__ + "img/lasting_from_ts_logo_black.de983726.svg";